<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-chip v-bind="attrs" v-on="on" :color="active ? 'primary' : ''">
        <v-icon small left>mdi-filter</v-icon>
        {{ label }}
      </v-chip>
    </template>

    <v-card>
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    label: String,
    active: Boolean
  },

  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>
